export default __webpack_public_path__ + "static/media/favicon.aeea50d7.svg";